export enum GenderEnum {
  Male = 'M',
  Female = 'F',
}

export const GenderOptions = [
  { checkValue: GenderEnum.Male, label: 'Male' },
  { checkValue: GenderEnum.Female, label: 'Female' },
];
